document.addEventListener("DOMContentLoaded", function () {
  async function fetchCollectionHandle(gid) {
    try {
      // Extrahera sista delen (collection-ID) från GID-strängen, t.ex. "640418218330"
      const collectionId = gid.split("/").pop();

      // Ange din butik och API-åtkomst
      const storefrontAPI = "https://wdxugd-yq.myshopify.com/api/2023-10/graphql.json";
      const accessToken = "a36d035e6554c29a534b9afa0d102ffe"; // Ersätt med ditt token

      const query = `
        query getCollection($id: ID!) {
          collection(id: $id) {
            handle
          }
        }
      `;
      const variables = { id: gid };

      const response = await fetch(storefrontAPI, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": accessToken
        },
        body: JSON.stringify({ query, variables })
      });

      const result = await response.json();
      if (result.data && result.data.collection && result.data.collection.handle) {
        return "/collections/" + result.data.collection.handle;
      } else {
        console.error("No collection data for GID:", gid, result);
        return null;
      }
    } catch (error) {
      console.error("Error fetching collection handle:", error);
      return null;
    }
  }

  async function processDynamicLinks() {
    // Hämta alla länkar med klasserna .konsttema-link och .artist-meta-link
    const links = document.querySelectorAll(".konsttema-link, .artist-meta-link");
    console.log("Found dynamic links:", links.length);

    for (const link of links) {
      const gid = link.dataset.gid;
      if (gid) {
        const trimmedGid = gid.trim();
        console.log("Fetching handle for GID:", trimmedGid);
        const url = await fetchCollectionHandle(trimmedGid);
        if (url) {
          link.href = url;
          console.log("Set link for", link.innerText, "to", url);
        } else {
          console.warn("No URL found for", link.innerText);
        }
      } else {
        console.warn("No GID found for link:", link.innerText);
      }
    }
  }

  processDynamicLinks();
});
